module.exports = __webpack_public_path__ + "static/media/download-circle.4f3204ad.svg";